import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'reactstrap'
import { DashBoardTitle } from '../../../Components/Title'
import RightImg from '../../../images/right.png'
import pendingImg from '../../../images/pending.png'
import './index.css'
import { useNavigate, useLocation } from 'react-router-dom'
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner'
import { Breadcrumbs } from '../../../Components/Breadcrumbs/Breadcrumbs'
import { BreadCrumbBackButton } from '../../../Components/Breadcrumbs/BreadCrumbBackButton'
import Storage from "../../../services/Storage";
import { CommonButton } from '../../../Components/CommonComponents'
import { useDispatch, useSelector } from 'react-redux'
import { dealerInfoAction, DEALER_DETAIL } from '../../../reducers/DealerReducer'
import AppHeader from '../../../Layout/AppHeader'
import AppSidebar from '../../../Layout/AppSidebar'

const NewDealerCard = () => {

    const [isLoading, setIsloading] = useState(false);
    const initialState = { page1: null, page2: null, page3: null, page4: null, page5: null, page6: null, page7: null, page8: null, isApproved: false };
    const [cardStatus, setCardStatus] = useState(initialState);
    const [title, setTitle] = useState({});

    const location = useLocation();
    const navigate = useNavigate();
    let stringArr = location.pathname.split(/(\d+)/);
    let dealerId = stringArr[1];

    const dispatch = useDispatch();
    const { dealerObj } = useSelector(state => state.DealerReducer);

    useEffect(() => {
        setIsloading(true)
        getCardStyle(dealerId)
    }, [])

    useEffect(() => {
        setCardStatus({ ...cardStatus, page1: dealerObj.page_1, page2: dealerObj.page_2, page3: dealerObj.page_3, page4: dealerObj.page_4, page5: dealerObj.page_5, page6: dealerObj.page_6, page7: dealerObj.page_7, page8: dealerObj.page_8, isApproved: dealerObj.is_approved })
        setIsloading(false);
        // if(dealerId) {
        //     setTitle({ name: dealerObj.business_name, isVerified: dealerObj.is_verified });
        // } else{
        //     setTitle({});
        // }
        setTitle({ name: dealerObj.business_name, isVerified: dealerObj.is_verified });
    }, [dealerObj])

    const getCardStyle = () => {
        if (dealerId) {
            dispatch(dealerInfoAction(parseInt(dealerId), setIsloading));
        } else {
            setIsloading(false);
            dispatch({
                type: DEALER_DETAIL,
                data: {}
            })
        }
    }
    const setBreadcrumbsRecord = () => {
        Storage.setBreadcrumbsrRecord([
            {
                title: title.name ? title.name : "New Dealer Registration",
                url: location.pathname,
            },
        ])
    }

    return (
        <>
            <AppHeader />
            <div className='app-main'>
                <AppSidebar />
                <div className='app-main__outer'>
                    <div className='app-main__inner rms-wrapper'>
                        <div id='newDealerCard'>
                            {isLoading && <CustomSpinner />}
                            <Container fluid>
                                <Row>
                                    <Col xs={12}>
                                        <div className='pageheader'>
                                            <DashBoardTitle dashBorardName={cardStatus.page1 === 1 && cardStatus.page2 === 1 && cardStatus.page3 === 1 && cardStatus.page4 === 1 && cardStatus.page5 === 1 && cardStatus.page6 === 1 && cardStatus.page7 === 1 && cardStatus.page8 === 1 ? title.name : "New Dealer Registration"} />
                                            <BreadCrumbBackButton />
                                        </div>
                                    </Col>
                                    <Col xs={12}>
                                        <Breadcrumbs title={title.name ? title.name : "New Dealer Registration"} />
                                    </Col>
                                    <Col xs={12}>
                                        <div className='topText commonNote'>This is a new dealer registration form. There are total 8 sections. Once all the sections are completed, a “Submit for Approval” button will be enabled.
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={4} sm={6} className="d-flex align-items-stretch">
                                        <div className='cardBlock' id='cardblock1'
                                            onClick={() => {
                                                setBreadcrumbsRecord();
                                                if (dealerId) {
                                                    navigate(`/pages/basic-business-info/${dealerId}`)
                                                } else {
                                                    navigate(`/pages/basic-business-info`)
                                                }
                                            }}
                                            style={{
                                                border: ((dealerId && cardStatus.page1 === 0) && '1px solid #FFF500') || ((dealerId && cardStatus.page1 === 1) && '1px solid #00FF00'),
                                            }}
                                        >
                                            <div className='title'>Business Information</div>
                                            <div className='description'>In this section, dealer’s basic information like firm, address and contact details are collected.</div>
                                            {(dealerId && cardStatus.page1 === 1) && <img src={RightImg} alt='img' className='d-block ml-auto' />}
                                            {(dealerId && cardStatus.page1 === 0) && <img src={pendingImg} alt='img' className='d-block ml-auto' />}
                                        </div>
                                    </Col>
                                    <Col lg={4} sm={6} className="d-flex align-items-stretch">
                                        <div className='cardBlock' id='cardblock7'
                                            onClick={() => {
                                                setBreadcrumbsRecord();
                                                if (dealerId) {
                                                    navigate(`/pages/add-owner/${dealerId}`)
                                                }

                                            }}
                                            style={{
                                                background: dealerId ? '#ffffff' : '#dbdbdb',
                                                cursor: dealerId ? 'pointer' : 'auto',
                                                border: ((dealerId && cardStatus.page7 === 0) && '1px solid #FFF500') || ((dealerId && cardStatus.page7 === 1) && '1px solid #00FF00'),
                                            }}
                                        >
                                            <div className='title'>Owner’s Information</div>
                                            <div className='description'>In this section, dealer’s personal information including mobile, emails and social details are captured.</div>
                                            {(dealerId && cardStatus.page7 === 1) && <img src={RightImg} alt='img' className='d-block ml-auto' />}
                                            {(dealerId && cardStatus.page7 === 0) && <img src={pendingImg} alt='img' className='d-block ml-auto' />}
                                        </div>
                                    </Col>
                                    <Col lg={4} sm={6} className="d-flex align-items-stretch">
                                        <div className='cardBlock' id='cardblock2'
                                            onClick={() => {
                                                setBreadcrumbsRecord();
                                                if (dealerId) {
                                                    navigate(`/pages/crop-acreages/${dealerId}`)
                                                }
                                            }}
                                            style={{
                                                background: dealerId ? '#ffffff' : '#dbdbdb',
                                                cursor: dealerId ? 'pointer' : 'auto',
                                                border: ((dealerId && cardStatus.page2 === 0) && '1px solid #FFF500') || ((dealerId && cardStatus.page2 === 1) && '1px solid #00FF00'),
                                            }}
                                        >
                                            <div className='title'>Coverage Area Details</div>
                                            <div className='description'>In this section, crop acreages of Rabi and Kharif seasons for top four crops are collected.</div>
                                            {(dealerId && cardStatus.page2 === 1) && <img src={RightImg} alt='img' className='d-block ml-auto' />}
                                            {(dealerId && cardStatus.page2 === 0) && <img src={pendingImg} alt='img' className='d-block ml-auto' />}
                                        </div>
                                    </Col>
                                    <Col lg={4} sm={6} className="d-flex align-items-stretch">
                                        <div className='cardBlock' id='cardblock3'
                                            onClick={() => {
                                                setBreadcrumbsRecord();
                                                if (dealerId) {
                                                    navigate(`/pages/advance-business-details/${dealerId}`)
                                                }
                                            }}
                                            // onClick={() => dealerId ? navigate(`/pages/advance-business-details/${dealerId}`) : undefined}
                                            style={{
                                                background: dealerId ? '#ffffff' : '#dbdbdb',
                                                cursor: dealerId ? 'pointer' : 'auto',
                                                border: ((dealerId && cardStatus.page3 === 0) && '1px solid #FFF500') || ((dealerId && cardStatus.page3 === 1) && '1px solid #00FF00'),
                                            }}
                                        >
                                            <div className='title'>Advance Business Details</div>
                                            <div className='description'>In this section, all the necessary documents and their numbers including bank & security are collected.</div>
                                            {(dealerId && cardStatus.page3 === 1) && <img src={RightImg} alt='img' className='d-block ml-auto' />}
                                            {(dealerId && cardStatus.page3 === 0) && <img src={pendingImg} alt='img' className='d-block ml-auto' />}
                                        </div>
                                    </Col>
                                    <Col lg={4} sm={6} className="d-flex align-items-stretch">
                                        <div className='cardBlock' id='cardblock4'
                                            onClick={() => {
                                                setBreadcrumbsRecord();
                                                if (dealerId) {
                                                    navigate(`/pages/credit-limit-n-risk-measure-tag/${dealerId}`)
                                                }
                                            }}
                                            style={{
                                                background: dealerId ? '#ffffff' : '#dbdbdb',
                                                cursor: dealerId ? 'pointer' : 'auto',
                                                border: ((dealerId && cardStatus.page4 === 0) && '1px solid #FFF500') || ((dealerId && cardStatus.page4 === 1) && '1px solid #00FF00'),
                                            }}
                                        >
                                            <div className='title'>Credit Limit & Risk Measure</div>
                                            <div className='description'>In this section, dealer’s credit limit, risk measure tag and cash/credit ratios are proposed.</div>
                                            {(dealerId && cardStatus.page4 === 1) && <img src={RightImg} alt='img' className='d-block ml-auto' />}
                                            {(dealerId && cardStatus.page4 === 0) && <img src={pendingImg} alt='img' className='d-block ml-auto' />}
                                        </div>
                                    </Col>
                                    <Col lg={4} sm={6} className="d-flex align-items-stretch">
                                        <div className='cardBlock' id='cardblock5'
                                            onClick={() => {
                                                setBreadcrumbsRecord();
                                                if (dealerId) {
                                                    navigate(`/pages/business-commitment/${dealerId}`)
                                                }
                                            }}
                                            style={{
                                                background: dealerId ? '#ffffff' : '#dbdbdb',
                                                cursor: dealerId ? 'pointer' : 'auto',
                                                border: ((dealerId && cardStatus.page5 === 0) && '1px solid #FFF500') || ((dealerId && cardStatus.page5 === 1) && '1px solid #00FF00'),
                                            }}
                                        >
                                            <div className='title'>Business Commitment</div>
                                            <div className='description'>In this section, dealer’s next 3 years business commitment is collected and upload it on their letter head.</div>
                                            {(dealerId && cardStatus.page5 === 1) && <img src={RightImg} alt='img' className='d-block ml-auto' />}
                                            {(dealerId && cardStatus.page5 === 0) && <img src={pendingImg} alt='img' className='d-block ml-auto' />}
                                        </div>
                                    </Col>
                                    <Col lg={4} sm={6} className="d-flex align-items-stretch">
                                        <div className='cardBlock' id='cardblock6'
                                            onClick={() => {
                                                setBreadcrumbsRecord();
                                                if (dealerId) {
                                                    navigate(`/pages/business-competition-insights/${dealerId}`)
                                                }
                                            }}
                                            style={{
                                                background: dealerId ? '#ffffff' : '#dbdbdb',
                                                cursor: dealerId ? 'pointer' : 'auto',
                                                border: ((dealerId && cardStatus.page6 === 0) && '1px solid #FFF500') || ((dealerId && cardStatus.page6 === 1) && '1px solid #00FF00'),
                                            }}
                                        >
                                            <div className='title'>Competition Insights</div>
                                            <div className='description'>In this section, dealer’s last year input-wise and company-wise business performances are captured.</div>
                                            {(dealerId && cardStatus.page6 === 1) && <img src={RightImg} alt='img' className='d-block ml-auto' />}
                                            {(dealerId && cardStatus.page6 === 0) && <img src={pendingImg} alt='img' className='d-block ml-auto' />}
                                        </div>
                                    </Col>

                                    <Col lg={4} sm={6} className="d-flex align-items-stretch">
                                        <div className='cardBlock' id='cardblock8'
                                            onClick={() => {
                                                setBreadcrumbsRecord();
                                                if (dealerId) {
                                                    navigate(`/pages/primary-contact-info/${dealerId}`)
                                                }
                                            }}
                                            style={{
                                                background: dealerId ? '#ffffff' : '#dbdbdb',
                                                cursor: dealerId ? 'pointer' : 'auto',
                                                border: ((dealerId && cardStatus.page8 === 0) && '1px solid #FFF500') || ((dealerId && cardStatus.page8 === 1) && '1px solid #00FF00'),
                                            }}
                                        >
                                            <div className='title'>Primary Contact Information</div>
                                            <div className='description'>In this section, dealer’s primary contact person like manage etc are captured.</div>
                                            {(dealerId && cardStatus.page8 === 1) && <img src={RightImg} alt='img' className='d-block ml-auto' />}
                                            {(dealerId && cardStatus.page8 === 0) && <img src={pendingImg} alt='img' className='d-block ml-auto' />}
                                        </div>
                                    </Col>
                                    <Col xs={12}>
                                        <div className='btnBlock text-center'>
                                            <CommonButton
                                                name={cardStatus.isApproved === true ? 'Preview Profile' : 'Preview Application'}
                                                btnClass={'btnSecondary ml-3 mr-3'}
                                                disabled={!dealerId}
                                                maxWidth='180px'
                                                type="button"
                                                onClick={() => {
                                                    setBreadcrumbsRecord();
                                                    if (dealerId) { navigate(`/pages/preview-app/${dealerId}`) }
                                                }}
                                            />
                                            {title.isVerified === null || title.isVerified === false ?
                                                <CommonButton
                                                    name={'Verification'}
                                                    btnClass={'btnPrimary ml-3 mr-3'}
                                                    disabled={!(dealerId && (cardStatus.page1 === 1 && cardStatus.page2 === 1 && cardStatus.page3 === 1 && cardStatus.page4 === 1 && cardStatus.page5 === 1 && cardStatus.page6 === 1 && cardStatus.page7 === 1 && cardStatus.page8 === 1))}
                                                    maxWidth='180px'
                                                    type="button"
                                                    onClick={() => {
                                                        setBreadcrumbsRecord();
                                                        if (dealerId && (cardStatus.page1 === 1 && cardStatus.page2 === 1 && cardStatus.page3 === 1 && cardStatus.page4 === 1 && cardStatus.page5 === 1 && cardStatus.page6 === 1 && cardStatus.page7 === 1 && cardStatus.page8 === 1)) {
                                                            navigate(`/pages/verify-n-submit/${dealerId}`)
                                                        }
                                                    }}
                                                />
                                                : ''}
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NewDealerCard